export const CONTENT_VIEW_FROM_KEY = 'content_view_from'
